document.addEventListener('DOMContentLoaded', () => {

  let siteID = "1230";
  let siteKey = "06c7784e67cc0b9f1658941479778fa1";
  let projectHandles = 68;
  let action = "encrypt";
  let siteAUTH = sample_code(action, CryptoJS.MD5(siteKey + siteID).toString(), siteID + siteKey);

  getData(siteID, siteKey, siteAUTH, projectHandles);

  function getData(siteID, siteKey, siteAUTH, projectHandles) {
    const formData = new URLSearchParams();
    formData.append("siteID", siteID);
    formData.append("siteKey", siteKey);
    formData.append("siteAUTH", siteAUTH);
    formData.append("projectHandles", projectHandles);
    fetch("https://share.iequalchange.com/public/api/donations/livetotalsitebyproject", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString()
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success: ", data);

        // Project ID for each block now comes from the section settings
        // (data-project-id, set via the "i=Change project ID" field in the
        // theme editor) instead of being hardcoded here. Merchants can update
        // it directly if i=Change enables/disables/swaps a project.
        let impactEls = document.querySelectorAll('.giving_back-block .giving-back_block-heading .giving-back_block-impact');

        impactEls.forEach((givingBackBlockImpact) => {
          let projectId = Number(givingBackBlockImpact.getAttribute('data-project-id'));
          if (!projectId) {
            console.warn('i=Change: no data-project-id set on block', givingBackBlockImpact);
            return;
          }

          let project = data?.project_details?.find((p) => p.project_id === projectId);
          if (!project) {
            console.warn(`i=Change: project ${projectId} not found in project_details (it may be disabled - check project_details_disabled)`);
            return;
          }

          let showData = givingBackBlockImpact.getAttribute('data-show');
          let value = project.project_impact?.[showData];
          if (value === undefined) {
            console.warn(`i=Change: impact measure "${showData}" missing for project ${projectId}`);
            return;
          }

          givingBackBlockImpact.innerHTML = Number(value.split(' ')[0]);
        });
      })
      .catch((error) => {
        console.log("Error:", error);
      });

  }

  function sample_code(action, secret, string) {
    var Sha256 = CryptoJS.SHA256;
    var Hex = CryptoJS.enc.Hex;
    var Utf8 = CryptoJS.enc.Utf8;
    var Base64 = CryptoJS.enc.Base64;
    var AES = CryptoJS.AES;
    var secret_key = secret.toString();
    var secret_iv = CryptoJS.MD5(secret_key + "iv").toString();
    var key = Hex.parse(Sha256(secret_key).toString().substring(0, 32));
    var iv1 = Sha256(secret_iv).toString().substring(0, 16);
    var iv = Hex.parse(iv1.substr(0, 16).toString());
    if (action == 'encrypt') {
      var outputE = AES.encrypt(string, Utf8.parse(key), {
        iv: Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      var encrypted = btoa(outputE).toString();
      return encrypted;
    } else if (action == 'decrypt') {
      var outputD = AES.decrypt(atob(string), Utf8.parse(key),
        {
          iv: Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString(Utf8);
      var decrypted = outputD.toString(Utf8);
      return decrypted;
    }
  }
})
